import type { VariationComponent } from "~types/types";
import {
    type IntegrityStatus,
    checkModulePropsExist,
} from "~utils/moduleIntegrity";

export default function integrityCheck(
    props: VariationComponent
): IntegrityStatus {
    const messages = checkModulePropsExist(props, ["id"]);
    return messages;
}
